import { ColorOptions, Icon, ModBox, Spacer, Text, TextInputNewProps } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import React, { useState } from 'react'
import { useStores } from '../../data/store'
import { List } from './List'

const ApiOnboarding = ({ mid, showSuccess }: any) => {
  const [mercName, setMercName] = useState('')
  const { updateMercName, listData } = useStores((store) => ({
    updateMercName: store.onboarding.updateMercName,
    listData: store.onboarding.getApiOnboardedData(),
  }))

  const handleOnChange = (val: string) => {
    setMercName(val)
    const isValidMid = val.length >= 3
    isValidMid ? updateMercName(val) : updateMercName('')
  }

  return (
    <>
      <ModBox show={showSuccess} f={1} justify={'center'} align={'center'} ph={80} pv={24}>
        <Icon id={'SUCCESSFUL_FILLED'} color={'#00840F' as ColorOptions} size={64} />
        <Spacer size={24} direction={'vertical'} />
        <Text
          title={'Onboarding is done.\nPlease proceed for the next steps.'}
          color={'BLACK_21'}
          fontSize={18}
          fontFamily={'jiotype-bold'}
          textAlign={'center'}
        />
        <Spacer size={24} direction={'vertical'} />
        <Text
          title={'In the next steps, you can do General Configuration, Payment Configuration and\nAPI Configuration.'}
          color={'PRIMARY_GREY'}
          fontSize={14}
          fontFamily={'jiotype-medium'}
          textAlign={'center'}
        />
        <Spacer size={24} direction={'vertical'} />

        <List data={listData} />
      </ModBox>
      <ModBox show={!showSuccess} f={1} ph={80} pv={54}>
        <Text title={'Onboarding'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <Spacer size={32} direction={'vertical'} />
        <TextInputNew
          value={mid}
          {...styles.textinput}
          label={'MID'}
          editable={false}
          focusBorderColor={'DISABLED_GREY'}
        />
        <Spacer size={24} direction={'vertical'} />
        <TextInputNew
          {...styles.textinput}
          label={'Merchant Name'}
          value={mercName}
          onChange={handleOnChange}
          maxLength={15}
        />
      </ModBox>
    </>
  )
}

const styles = {
  textinput: {
    borderRadius: 4,
    borderColor: 'DISABLED_GREY',
    height: 32,
    type: 'body12',
    labelPaddingBottom: 8,
    labelFontFamily: 'jiotype-bold',
    fontFamily: 'jiotype-medium',
    labelColor: 'BRAND_COLOR_GRAY_1',
    labelFontSize: 12,
    fontSize: 12,
    paddingHorizontal: 8,
  } as TextInputNewProps,
}
export default ApiOnboarding
